import { getAllQuickLinksForInstitution, createOrUpdateQuickLink, deleteMultipleQuickLinks } from '../api'

export const loadAllQuickLinksForInstitution = ({ state, commit }) => {
  return getAllQuickLinksForInstitution()
}

export const createQuickLink = ({ state, commit }, quickLink) => {
  return createOrUpdateQuickLink(quickLink)
}

export const deleteSeletedQuickLink = ({ state, commit }, uuids) => {
  return deleteMultipleQuickLinks(uuids)
}



// WEBPACK FOOTER //
// ./src/app/quickLink/vuex/actions.js